module.exports = __webpack_public_path__ + "static/media/logo_pn_invert_fr.cfeb8a3a.svg";